import { render, staticRenderFns } from "./ElSelect.vue?vue&type=template&id=16183ed5"
import script from "./ElSelect.vue?vue&type=script&lang=js"
export * from "./ElSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports